// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── Dark Mode (default) ── */
.internal-root,
.internal-root[data-theme=dark] {
  --hue: 0;
  --sat: 0%;
  /* Backgrounds */
  --bg-base: hsl(var(--hue), var(--sat), 0%);
  --bg-surface: hsl(var(--hue), var(--sat), 8%);
  --bg-raised: rgba(18, 19, 24, 0.98);
  --bg-raised-purple: hsl(270, 30%, 5%);
  --bg-inset: rgba(0, 0, 0, 0.2);
  --bg-topbar: rgba(18, 19, 24, 0.9);
  --bg-backdrop: rgba(0, 0, 0, 0.5);
  --bg-lightbox: rgba(0, 0, 0, 0.88);
  --bg-code-block: rgba(0, 0, 0, 0.35);
  /* Fills (surface overlays) */
  --fill-subtle: rgba(255, 255, 255, 0.03);
  --fill-light: rgba(255, 255, 255, 0.05);
  --fill-default: rgba(255, 255, 255, 0.06);
  --fill-hover: rgba(255, 255, 255, 0.08);
  --fill-active: rgba(255, 255, 255, 0.1);
  --fill-strong: rgba(255, 255, 255, 0.12);
  /* Text */
  --text-primary: hsl(var(--hue), var(--sat), 90%);
  --text-muted: hsl(var(--hue), var(--sat), 70%);
  --text-heading: rgba(230, 230, 234, 0.95);
  --text-strong: rgba(230, 230, 234, 0.85);
  --text-body: rgba(230, 230, 234, 0.75);
  --text-secondary: rgba(230, 230, 234, 0.65);
  --text-tertiary: rgba(230, 230, 234, 0.55);
  --text-faint: rgba(230, 230, 234, 0.4);
  --text-primary-filter: brightness(90%);
  --text-muted-filter: brightness(60%);
  /* Borders */
  --border-color: hsl(var(--hue), var(--sat), 20%);
  --highlight-color: hsl(var(--hue), var(--sat), 25%);
  --border-subtle: rgba(255, 255, 255, 0.06);
  --border-default: rgba(255, 255, 255, 0.08);
  --border-moderate: rgba(255, 255, 255, 0.1);
  --border-medium: rgba(255, 255, 255, 0.12);
  --border-strong: rgba(255, 255, 255, 0.15);
  --border-focus: rgba(255, 255, 255, 0.2);
  /* Brand / Semantic */
  --primary-hue: 250;
  --primary: hsl(var(--primary-hue), 80%, 60%);
  --button-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(0, 0, 0, 0.12)), var(--primary);
  --color-error: #ff6b6b;
  --color-error-hover: #ff4d4d;
  --color-link: #8b8bf5;
  /* Misc */
  --spinner-track: rgba(255, 255, 255, 0.1);
  color-scheme: dark;
}

/* ── Light Mode ── */
.internal-root[data-theme=light] {
  --hue: 0;
  --sat: 0%;
  /* Backgrounds */
  --bg-base: #f8f8fa;
  --bg-surface: #ffffff;
  --bg-raised: rgba(255, 255, 255, 0.98);
  --bg-raised-purple: hsl(270, 40%, 97%);
  --bg-inset: rgba(0, 0, 0, 0.04);
  --bg-topbar: rgba(255, 255, 255, 0.92);
  --bg-backdrop: rgba(0, 0, 0, 0.3);
  --bg-lightbox: rgba(0, 0, 0, 0.75);
  --bg-code-block: rgba(0, 0, 0, 0.04);
  /* Fills (surface overlays) */
  --fill-subtle: rgba(0, 0, 0, 0.02);
  --fill-light: rgba(0, 0, 0, 0.03);
  --fill-default: rgba(0, 0, 0, 0.04);
  --fill-hover: rgba(0, 0, 0, 0.06);
  --fill-active: rgba(0, 0, 0, 0.08);
  --fill-strong: rgba(0, 0, 0, 0.1);
  /* Text */
  --text-primary: #1a1a2e;
  --text-muted: #5c5c6e;
  --text-heading: #111122;
  --text-strong: #2a2a3c;
  --text-body: #3d3d50;
  --text-secondary: #5c5c6e;
  --text-tertiary: #7a7a8c;
  --text-faint: #a0a0b0;
  --text-primary-filter: brightness(30%);
  --text-muted-filter: brightness(50%);
  /* Borders */
  --border-color: #d8d8e0;
  --highlight-color: #c8c8d2;
  --border-subtle: rgba(0, 0, 0, 0.06);
  --border-default: rgba(0, 0, 0, 0.1);
  --border-moderate: rgba(0, 0, 0, 0.12);
  --border-medium: rgba(0, 0, 0, 0.15);
  --border-strong: rgba(0, 0, 0, 0.18);
  --border-focus: rgba(0, 0, 0, 0.25);
  /* Brand / Semantic */
  --primary-hue: 250;
  --primary: hsl(var(--primary-hue), 70%, 55%);
  --button-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(0, 0, 0, 0.05)), var(--primary);
  --color-error: #d93025;
  --color-error-hover: #c22a1e;
  --color-link: #5e5ed2;
  /* Misc */
  --spinner-track: rgba(0, 0, 0, 0.1);
  color-scheme: light;
}

textarea:focus {
  outline: none;
}

.internal-root {
  background-color: var(--bg-base);
  color: var(--text-primary);
  height: 100vh;
  overflow: hidden;
  /* Firefox */
  scrollbar-color: var(--highlight-color) var(--bg-base);
  scrollbar-width: auto;
}

/* WebKit (Chrome/Safari/Edge) */
.internal-root ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.internal-root ::-webkit-scrollbar-track {
  background: var(--bg-base);
}

.internal-root ::-webkit-scrollbar-thumb {
  background-color: var(--highlight-color);
  border-radius: 999px;
  border: 2px solid var(--bg-base);
}

.internal-root ::-webkit-scrollbar-thumb:hover {
  background-color: var(--primary);
}

.internal-root ::-webkit-scrollbar-corner {
  background: var(--bg-base);
}

/* .internal-root a { */
/*   color: inherit; */
/* } */
.internal-root .card {
  background-color: var(--bg-raised);
  color: var(--text-primary);
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  border-top: 1px solid var(--highlight-color);
  transition: transform 0.18s ease;
  will-change: transform;
}

.internal-root .card:hover {
  background: linear-gradient(var(--bg-raised), var(--bg-surface)) padding-box, linear-gradient(to bottom, var(--highlight-color), var(--border-color)) border-box;
  /* Ensure the border is transparent so the gradient shows through */
  border-color: transparent;
}

.internal-root .btn-primary {
  background-color: var(--primary);
  color: #fff;
  border: 1px solid transparent;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.internal-root .btn-primary:hover {
  opacity: 0.9;
}

.internal-root .btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/internal/styles/internal.global.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,8BAAA;AACA;;EAEE,QAAA;EACA,SAAA;EAEA,gBAAA;EACA,0CAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,6BAAA;EACA,wCAAA;EACA,uCAAA;EACA,yCAAA;EACA,uCAAA;EACA,uCAAA;EACA,wCAAA;EAEA,SAAA;EACA,gDAAA;EACA,8CAAA;EACA,yCAAA;EACA,wCAAA;EACA,sCAAA;EACA,2CAAA;EACA,0CAAA;EACA,sCAAA;EAEA,sCAAA;EACA,oCAAA;EAEA,YAAA;EACA,gDAAA;EACA,mDAAA;EACA,0CAAA;EACA,2CAAA;EACA,2CAAA;EACA,0CAAA;EACA,0CAAA;EACA,wCAAA;EAEA,qBAAA;EACA,kBAAA;EACA,4CAAA;EACA,6GAAA;EACA,sBAAA;EACA,4BAAA;EACA,qBAAA;EAEA,SAAA;EACA,yCAAA;EAEA,kBAAA;AANF;;AASA,qBAAA;AACA;EACE,QAAA;EACA,SAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sCAAA;EACA,sCAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,6BAAA;EACA,kCAAA;EACA,iCAAA;EACA,mCAAA;EACA,iCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,SAAA;EACA,uBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,sCAAA;EACA,oCAAA;EAEA,YAAA;EACA,uBAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,sCAAA;EACA,oCAAA;EACA,oCAAA;EACA,mCAAA;EAEA,qBAAA;EACA,kBAAA;EACA,4CAAA;EACA,6GAAA;EACA,sBAAA;EACA,4BAAA;EACA,qBAAA;EAEA,SAAA;EACA,mCAAA;EAEA,mBAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,gCAAA;EACA,0BAAA;EACA,aAAA;EACA,gBAAA;EAEA,YAAA;EACA,sDAAA;EACA,qBAAA;AAfF;;AAkBA,gCAAA;AACA;EACE,WAAA;EACA,YAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF;;AAkBA;EACE,wCAAA;EACA,oBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,gCAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF;;AAkBA,uBAAA;AACA,sBAAA;AACA,MAAA;AAEA;EACE,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EAEA,qCAAA;EACA,4CAAA;EAEA,gCAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,gKAEA;EAIA,mEAAA;EACA,yBAAA;AAvBF;;AA0BA;EACE,gCAAA;EACA,WAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAvBF;;AA0BA;EACE,YAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,mBAAA;AAvBF","sourcesContent":["/* ── Dark Mode (default) ── */\n.internal-root,\n.internal-root[data-theme=\"dark\"] {\n  --hue: 0;\n  --sat: 0%;\n\n  /* Backgrounds */\n  --bg-base: hsl(var(--hue), var(--sat), 0%);\n  --bg-surface: hsl(var(--hue), var(--sat), 8%);\n  --bg-raised: rgba(18, 19, 24, 0.98);\n  --bg-raised-purple: hsl(270, 30%, 5%);\n  --bg-inset: rgba(0, 0, 0, 0.2);\n  --bg-topbar: rgba(18, 19, 24, 0.9);\n  --bg-backdrop: rgba(0, 0, 0, 0.5);\n  --bg-lightbox: rgba(0, 0, 0, 0.88);\n  --bg-code-block: rgba(0, 0, 0, 0.35);\n\n  /* Fills (surface overlays) */\n  --fill-subtle: rgba(255, 255, 255, 0.03);\n  --fill-light: rgba(255, 255, 255, 0.05);\n  --fill-default: rgba(255, 255, 255, 0.06);\n  --fill-hover: rgba(255, 255, 255, 0.08);\n  --fill-active: rgba(255, 255, 255, 0.1);\n  --fill-strong: rgba(255, 255, 255, 0.12);\n\n  /* Text */\n  --text-primary: hsl(var(--hue), var(--sat), 90%);\n  --text-muted: hsl(var(--hue), var(--sat), 70%);\n  --text-heading: rgba(230, 230, 234, 0.95);\n  --text-strong: rgba(230, 230, 234, 0.85);\n  --text-body: rgba(230, 230, 234, 0.75);\n  --text-secondary: rgba(230, 230, 234, 0.65);\n  --text-tertiary: rgba(230, 230, 234, 0.55);\n  --text-faint: rgba(230, 230, 234, 0.4);\n\n  --text-primary-filter: brightness(90%);\n  --text-muted-filter: brightness(60%);\n\n  /* Borders */\n  --border-color: hsl(var(--hue), var(--sat), 20%);\n  --highlight-color: hsl(var(--hue), var(--sat), 25%);\n  --border-subtle: rgba(255, 255, 255, 0.06);\n  --border-default: rgba(255, 255, 255, 0.08);\n  --border-moderate: rgba(255, 255, 255, 0.1);\n  --border-medium: rgba(255, 255, 255, 0.12);\n  --border-strong: rgba(255, 255, 255, 0.15);\n  --border-focus: rgba(255, 255, 255, 0.2);\n\n  /* Brand / Semantic */\n  --primary-hue: 250;\n  --primary: hsl(var(--primary-hue), 80%, 60%);\n  --button-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(0, 0, 0, 0.12)), var(--primary);\n  --color-error: #ff6b6b;\n  --color-error-hover: #ff4d4d;\n  --color-link: #8b8bf5;\n\n  /* Misc */\n  --spinner-track: rgba(255, 255, 255, 0.1);\n\n  color-scheme: dark;\n}\n\n/* ── Light Mode ── */\n.internal-root[data-theme=\"light\"] {\n  --hue: 0;\n  --sat: 0%;\n\n  /* Backgrounds */\n  --bg-base: #f8f8fa;\n  --bg-surface: #ffffff;\n  --bg-raised: rgba(255, 255, 255, 0.98);\n  --bg-raised-purple: hsl(270, 40%, 97%);\n  --bg-inset: rgba(0, 0, 0, 0.04);\n  --bg-topbar: rgba(255, 255, 255, 0.92);\n  --bg-backdrop: rgba(0, 0, 0, 0.3);\n  --bg-lightbox: rgba(0, 0, 0, 0.75);\n  --bg-code-block: rgba(0, 0, 0, 0.04);\n\n  /* Fills (surface overlays) */\n  --fill-subtle: rgba(0, 0, 0, 0.02);\n  --fill-light: rgba(0, 0, 0, 0.03);\n  --fill-default: rgba(0, 0, 0, 0.04);\n  --fill-hover: rgba(0, 0, 0, 0.06);\n  --fill-active: rgba(0, 0, 0, 0.08);\n  --fill-strong: rgba(0, 0, 0, 0.1);\n\n  /* Text */\n  --text-primary: #1a1a2e;\n  --text-muted: #5c5c6e;\n  --text-heading: #111122;\n  --text-strong: #2a2a3c;\n  --text-body: #3d3d50;\n  --text-secondary: #5c5c6e;\n  --text-tertiary: #7a7a8c;\n  --text-faint: #a0a0b0;\n\n  --text-primary-filter: brightness(30%);\n  --text-muted-filter: brightness(50%);\n\n  /* Borders */\n  --border-color: #d8d8e0;\n  --highlight-color: #c8c8d2;\n  --border-subtle: rgba(0, 0, 0, 0.06);\n  --border-default: rgba(0, 0, 0, 0.1);\n  --border-moderate: rgba(0, 0, 0, 0.12);\n  --border-medium: rgba(0, 0, 0, 0.15);\n  --border-strong: rgba(0, 0, 0, 0.18);\n  --border-focus: rgba(0, 0, 0, 0.25);\n\n  /* Brand / Semantic */\n  --primary-hue: 250;\n  --primary: hsl(var(--primary-hue), 70%, 55%);\n  --button-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(0, 0, 0, 0.05)), var(--primary);\n  --color-error: #d93025;\n  --color-error-hover: #c22a1e;\n  --color-link: #5e5ed2;\n\n  /* Misc */\n  --spinner-track: rgba(0, 0, 0, 0.1);\n\n  color-scheme: light;\n}\n\ntextarea:focus {\n  outline:none;\n}\n\n.internal-root {\n  background-color: var(--bg-base);\n  color: var(--text-primary);\n  height: 100vh;\n  overflow: hidden;\n\n  /* Firefox */\n  scrollbar-color: var(--highlight-color) var(--bg-base);\n  scrollbar-width: auto;\n}\n\n/* WebKit (Chrome/Safari/Edge) */\n.internal-root ::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.internal-root ::-webkit-scrollbar-track {\n  background: var(--bg-base);\n}\n\n.internal-root ::-webkit-scrollbar-thumb {\n  background-color: var(--highlight-color);\n  border-radius: 999px;\n  border: 2px solid var(--bg-base);\n}\n\n.internal-root ::-webkit-scrollbar-thumb:hover {\n  background-color: var(--primary);\n}\n\n.internal-root ::-webkit-scrollbar-corner {\n  background: var(--bg-base);\n}\n\n/* .internal-root a { */\n/*   color: inherit; */\n/* } */\n\n.internal-root .card {\n  background-color: var(--bg-raised);\n  color: var(--text-primary);\n  padding: 1rem;\n  border-radius: 12px;\n\n  border: 1px solid var(--border-color);\n  border-top: 1px solid var(--highlight-color);\n\n  transition: transform 0.18s ease;\n  will-change: transform;\n}\n\n.internal-root .card:hover {\n  background: \n  /* Top layer: inner card color */\n  linear-gradient(var(--bg-raised), var(--bg-surface)) padding-box,\n  /* Bottom layer: the gradient you wanted */\n  linear-gradient(to bottom, var(--highlight-color), var(--border-color)) border-box;\n\n  /* Ensure the border is transparent so the gradient shows through */\n  border-color: transparent;\n}\n\n.internal-root .btn-primary {\n  background-color: var(--primary);\n  color: #fff;\n  border: 1px solid transparent;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.internal-root .btn-primary:hover {\n  opacity: 0.9;\n}\n\n.internal-root .btn-primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
